<template>
  <div>
    <b-navbar toggleable="lg" fixed="bottom" variant="transparent" class="justify-content-center">
      <b-nav>
        <p class="text-center my-2 text-light">Smartfarm Solutions Developed By Feed Business 2021 © Copyright Reseved</p>
      </b-nav>
    </b-navbar>
</div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
